import { render, staticRenderFns } from "./ConfigForm.vue?vue&type=template&id=5426b1c6&"
import script from "./ConfigForm.vue?vue&type=script&lang=js&"
export * from "./ConfigForm.vue?vue&type=script&lang=js&"
import style0 from "./ConfigForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports